/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"

export const DrawerStyles = css`
  .divider {
    height: 60px;
    background: #f5f5f5;
    padding: 20px;
    font-weight: 500;
    span {
      font-size: 16px;
    }
  }
  .pad-24 {
    padding: 24px;
  }
  .addNewModifierButton {
    color: #00a5cf;
    cursor: pointer;
  }
  .nameLabel::after {
    display: inline-block;
    margin-left: 4px;
    content: "*";
    font-family: SimSun;
    line-height: 1;
    font-size: 14px;
  }
  .additionalPriceLabel,
  .nameLabel {
    text-transform: uppercase;
    margin-top: 19px;
    margin-bottom: 12px;
    font-size: 12px;
    color: #2d2d2d;
    font-weight: 500;
  }
  .modifiersWrapper {
    padding: 20px;
  }
  .translationWrapper {
    padding: 0px 20px 20px 20px;
  }
  .draggerModifier {
    cursor: pointer;
  }
  .dash {
    min-height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .maximumInput label {
    font-size: 10px;
  }
  .emptyLinkedItemWrapper p {
    color: #979797;
  }
  .emptyLinkedItemWrapper button {
    padding-left: 57px;
    padding-right: 57px;
  }
  .editItemBtn {
    float: right;
    color: #00a5cf;
    cursor: pointer;
  }
  .pad-btm-80 {
    padding-bottom: 80px;
  }
  .deleteModifierSection {
    background: #f5f5f5;
    padding: 24px 16px 0 16px;
  }
  .name-form-item {
    margin: 30px 24px 23px 24px;
  }
  .name-form-item-no-top-margin {
    margin: 0 30px 23px 30px;
  }
  .linked-item-wrapper {
    padding: 0 24px 0 24px;
  }
  .linked-item-wrapper-pad-btm {
    padding: 0 24px 70px 24px;
  }
  .selection-rule-content {
    padding: 24px 24px 14px 24px;
  }
  .selection-rule-info {
    padding: 0 24px 24px 24px;
  }
`

export const LinkItemsDrawerStyles = css`
  .dui-list-item-meta {
    padding-top: 10px;
  }
  .sectionContent {
    position: absolute;
    margin-bottom: 50px;
    max-width: 100%;
    div {
      text-transform: uppercase;
      font-size: 12px;
      color: #2d2d2d;
      font-weight: 500;
      margin-bottom: 1em;
    }
  }
`
export const listItemWrapper = css`
  padding-bottom: 50px;
  .listItemWrapper {
    display: flex;
  }
  .listItemWrapper div:nth-of-type(1) {
    flex-grow: 1;
    margin-right: 8px;
    color: #2d2d2d;
  }
  .listItemWrapper span:nth-of-type(1) {
    color: #979797;
  }
  .dui-list-item {
    padding-top: 31px;
    padding-bottom: 27px;
  }
`

export const drawerFooter = css`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px 20px 16px;
  background: #fff;
  text-align: right;
  z-index: 9999;
`

export const headingStyle = css`
  text-transform: uppercase;
`

export const cardStyle = css`
  height: 100%;
  width: 100%;
  & > div {
    display: flex;
    flex-flow: column;
    height: 100%;
    .ant-card-head {
      margin-bottom: 0;
    }
    .ant-card-body {
      padding: 0px;
      flex-grow: 1;
      & > div {
        height: 100%;
      }
    }
  }
  /* .ant-card-body {
    border-top: solid 1px #ccd6dd;
    padding: 0;
  } */
`

export const sortableContainerStyle = css`
  height: 100%;
  .autoSizer {
    background-color: black;
  }
`

export const gridStyle = css`
  width: 100%;
  box-shadow: none;
  background-color: white;
  height: 100%;
  padding: 20px 24px;
  border-bottom: solid 1px #ccd6dd;
  &:hover {
    box-shadow: none !important;
    background-color: #f3f6fb;
  }
  * {
    font-size: 16px;
  }
`

export const modifierGroupPreviewDrawer = css`
  .item-img-wrapper {
    width: 100%;

    .item-img {
      max-width: 100%;
    }
  }
  .item-overview,
  .item-modifier {
    background: #fff;
    padding: 24px 15px;
  }
  .item-overview {
    .item-name,
    .item-price {
      font-weight: 500;
      font-size: 17px;
    }
    .item-price {
      margin-bottom: 0;
    }
    .base-price-label {
      margin-bottom: 0;
      font-size: 11px;
      color: #777575;
    }
  }
  .item-modifier {
    margin-top: 10px;
    .modifier-group-name {
      font-size: 16px;
      font-weight: 500;
    }
    .modifier-group-name span {
      font-size: 12px;
      font-weight: normal;
      color: #979797;
    }
  }
  .preview-content {
    background: #f5f5f5;
    height: 600px;
    overflow: scroll;
    border-radius: 17.1626px;
  }
  .modifier-wrapper {
    display: inline-block;
  }
  .dui-radio-wrapper {
    border-bottom: 1px solid rgba(5, 5, 5, 0.06);
  }
  .modifier-wrapper {
    width: 265px;
  }
  .modifier-wrapper span:nth-of-type(1) {
    font-size: 16px;
    color: #2d2d2d;
  }
  .modifier-wrapper span:nth-of-type(2) {
    font-size: 16px;
    color: #979797;
    float: right;
  }
  .item-description {
    background: #fff;
    padding: 0 15px;
    color: #979797;
  }
  .item-button {
    padding: 10px;
    background: #fff;
    button {
      background-color: #8a8a8a !important;
    }
  }
  .item-button-enabled {
    padding: 10px;
    background: #fff;
    button {
      background-color: #33c072 !important;
    }
  }
`

export const modifierGroupContainer = css`
  height: 100%;
  display: flex;
  flex-flow: column;
  .notif {
    border: 1px solid #33c066;
  }
`

export const antSelectedRed = css`
  .dui-select-selection-item {
    color: #f55538;
  }
`

export const tableCardStyle = css`
  border-radius: 8px;
  .ant-card-head {
    padding: 0 20px;
  }
  .ant-card-head-title {
    padding: 17px 0;
  }
`
